import { ChainId, chainNames } from '@pancakeswap/chains'
import memoize from 'lodash/memoize'
import {
  bsc as bsc_,
  bscTestnet,
  goerli,
  mainnet,
  zkSync,
  zkSyncTestnet,
  polygonZkEvmTestnet,
  polygonZkEvm,
  lineaTestnet,
  arbitrum,
  arbitrumGoerli,
  base,
  baseGoerli,
  scrollSepolia,
  opBNBTestnet,
  linea,
  opBNB,
  Chain,
} from 'wagmi/chains'

export const CHAIN_QUERY_NAME = chainNames

const CHAIN_QUERY_NAME_TO_ID = Object.entries(CHAIN_QUERY_NAME).reduce((acc, [chainId, chainName]) => {
  return {
    [chainName.toLowerCase()]: chainId as unknown as ChainId,
    ...acc,
  }
}, {} as Record<string, ChainId>)

export const getChainId = memoize((chainName: string) => {
  if (!chainName) return undefined
  return CHAIN_QUERY_NAME_TO_ID[chainName.toLowerCase()] ? +CHAIN_QUERY_NAME_TO_ID[chainName.toLowerCase()] : undefined
})

export const DEFAULT_CHAIN_ID =
  getChainId(process.env.NEXT_PUBLIC_DEFAULT_CHAIN || '') || ChainId.META_ASSETS_TESTNET

const bsc = {
  ...bsc_,
  rpcUrls: {
    ...bsc_.rpcUrls,
    public: {
      ...bsc_.rpcUrls.public,
      http: ['https://bsc-dataseed.binance.org/'],
    },
    default: {
      ...bsc_.rpcUrls.default,
      http: ['https://bsc-dataseed.binance.org/'],
    },
  },
} satisfies Chain

const metaAssets = {
  id: ChainId.META_ASSETS,
  name: 'Meta Assets Chain',
  network: 'meta-assets',
  nativeCurrency: {
    name: 'Meta Assets',
    symbol: 'MA',
    decimals: 18,
  },
  rpcUrls: {
    public: {
      http: [process.env.NEXT_PUBLIC_META_ASSETS_RPC || 'https://rpc.macscan.io'],
    },
    default: {
      http: [process.env.NEXT_PUBLIC_META_ASSETS_RPC || 'https://rpc.macscan.io'],
    },
  },
  blockExplorers: {
    default: {
      name: 'MacScan',
      url: 'https://macscan.io',
    },
  },
  contracts: {
    multicall3: {
      address: '0x0273E24134dCbC45Ed33F2f2a0064cDdEE5b4cC8',
    },
  },
} satisfies Chain

const metaAssetsTestnet = {
  id: ChainId.META_ASSETS_TESTNET,
  name: 'Meta Assets Chain Testnet',
  network: 'meta-assets-testnet',
  nativeCurrency: {
    name: 'Meta Assets',
    symbol: 'MA',
    decimals: 18,
  },
  rpcUrls: {
    public: {
      http: [process.env.NEXT_PUBLIC_META_ASSETS_TESTNET_RPC || 'https://rpc.machaintest.com'],
    },
    default: {
      http: [process.env.NEXT_PUBLIC_META_ASSETS_TESTNET_RPC || 'https://rpc.machaintest.com'],
    },
  },
  blockExplorers: {
    default: {
      name: 'MacScan Testnet',
      url: 'https://machaintest.com',
    },
  },
  contracts: {
    multicall3: {
      address: '0x6FA9d265C59765a2018959F5fd9AFB1Afa25Ba14',
    },
  },
  testnet: true,
} satisfies Chain

/**
 * Controls some L2 specific behavior, e.g. slippage tolerance, special UI behavior.
 * The expectation is that all of these networks have immediate transaction confirmation.
 */
export const L2_CHAIN_IDS: ChainId[] = [
  ChainId.ARBITRUM_ONE,
  ChainId.ARBITRUM_GOERLI,
  ChainId.POLYGON_ZKEVM,
  ChainId.POLYGON_ZKEVM_TESTNET,
  ChainId.ZKSYNC,
  ChainId.ZKSYNC_TESTNET,
  ChainId.LINEA_TESTNET,
  ChainId.LINEA,
  ChainId.BASE,
  ChainId.BASE_TESTNET,
  ChainId.OPBNB,
  ChainId.OPBNB_TESTNET,
  ChainId.META_ASSETS,
  ChainId.META_ASSETS_TESTNET,
]

export const CHAINS = [
  metaAssetsTestnet,
  metaAssets,
  bsc,
  mainnet,
  bscTestnet,
  goerli,
  polygonZkEvm,
  polygonZkEvmTestnet,
  zkSync,
  zkSyncTestnet,
  arbitrum,
  arbitrumGoerli,
  linea,
  lineaTestnet,
  arbitrumGoerli,
  arbitrum,
  base,
  baseGoerli,
  opBNB,
  opBNBTestnet,
  scrollSepolia,
]
